const Reducer = (state, action) => {
  switch (action.type) {
    case 'LOADING_USER_DATA':
      return {
        ...state,
        loading: action.payload,
      };
    case 'SET_PROFILE':
      return {
        ...state,
        profile: {
          ...state.profile,
          [action.payload.field]: action.payload.value,
        },
      };
    case 'GET_USER_DATA':
      return {
        ...state,
        profile: action.payload.data,
        success: false,
        loading: false,
        error: false,
        message: '',
        status: action.payload.status,
      };

    case 'RESET_MESSAGE':
      return {
        ...state,
        success: false,
        loading: false,
        error: false,
        message: false,
      };

    case 'UPDATE_MESSAGE':
      return {
        ...state,
        success: false,
        loading: false,
        error: false,
        message: false,
        ...action.payload,
      };

    case 'PROFILE_UPDATE':
      let data = action.payload.data;
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
        profile: data,
        user: {
          name: data.forename || data.username || data.email,
          job_title: data?.job_title,
          uid: data.id,
        },
        message: data ? 'Profile Updated' : '',
        status: action.payload.status,
      };

    case 'PASSWORD_UPDATE':
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
        fieldValues: false,
        profile: action.payload.data,
        message: action.payload.data ? 'Password Updated' : action.payload.data,
        status: action.payload.status,
      };

    case 'SERVICE_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status,
      };

    default:
      return state;
  }
};

export default Reducer;
